export const srErrors = {
	"http-login-error": "Greška u komunikaciji sa serverom",
};
